import { useEffect } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

import { designNumbers } from '../data';
import { extraQuestions } from '../constants/formSetup';

const SelectSport = ({ nextStep, handleChange, envParam, variant }) => {
  const handleSelectSport = sport => {
    let extraQuestionsKey = sport;

    const variantSportMapping = ['boa', 'boa2', 'hrd', 'warstic'];
    if (variant && variantSportMapping.includes(variant)) {
      extraQuestionsKey = variant;
    }

    handleChange({
      sport,
      designNumbers: [],
      numDesigns: '',
      extraQuestions: extraQuestions[extraQuestionsKey],
    });
    nextStep();
  };

  useEffect(() => {
    if (envParam === 'apparel') {
      handleSelectSport('apparel');
    } else if (envParam === 'greekjerseys.com') {
      handleSelectSport('greek');
    } else {
      // get url params and set sport
      const urlParams = new URLSearchParams(window.location.search);
      const sport = urlParams.get('sport');
      if (sport) {  // eslint-disable-line
        handleSelectSport(sport);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [envParam]);

  return (
    <StyledFormStep
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -50 }}
      transition={{ duration: 0.25 }}
    >
      <h2>Select your sport</h2>

      <div className="row">
        {Object.keys(designNumbers)
          .filter(sport => sport !== 'apparel')
          .map(sport => (
            <div
              key={sport}
              className="sport-container"
              onClick={() => handleSelectSport(sport)}
            >
              <div className={`img-container ${sport}-container`}>
                <h3 className="sport-name">{sport}</h3>
                <picture>
                  <source
                    srcSet={`https://res.cloudinary.com/team-triton/image/upload/f_auto,q_auto/select-sport/${sport}_Mobile_2`}
                    media="(max-width: 767px)"
                  />
                  <motion.img
                    src={`https://res.cloudinary.com/team-triton/image/upload/f_auto,q_auto/select-sport/${sport}_Desktop`}
                    alt={`${sport}`}
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 1.1 }}
                  />
                </picture>
              </div>
            </div>
          ))}
      </div>
    </StyledFormStep>
  );
};

const StyledFormStep = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 50px 20px 100px;

  h2 {
    margin-top: 0;
    text-transform: uppercase;
    font-weight: bold;
    text-align: center;
  }

  .row {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 70vh;
    margin: 0 auto;
    padding: 0 2rem;

    .sport-container {
      display: flex;
      flex: 1;
      max-width: 150px;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      gap: 20px;
      position: relative;
      cursor: pointer;
      height: 100%;

      @media (max-width: 767px) {
        width: 40%;
        min-width: 100px;
      }

      .sport-name {
        text-transform: uppercase;
        transform: rotate(-90deg);
        transform-origin: bottom right;
        position: absolute;
        top: -20px;
        right: -45px;
        transition: right 0.15s ease-in-out;
        color: #ccc !important;
        background-color: #333333dd;
        border-radius: 5px;
        box-shadow: 0 0 5px #000;
        padding: 10px;
        z-index: 3;
        font-weight: bold;
        font-size: 18px;

        @media (max-width: 767px) {
          display: none;
        }

        @media (max-width: 550px) {
          font-size: 2.25rem;
        }
      }

      &:hover {
        .sport-name {
          right: 5px;

          @media (max-width: 767px) {
            right: 38%;
          }
        }
      }

      .img-container {
        position: relative;
        overflow: hidden;
        width: 100%;
        object-fit: cover;

        img {
          width: 100%;
        }
      }

      @media (max-width: 990px) {
        button {
          padding: 0.75rem 1rem;
          font-size: 0.75rem;
        }
      }

      @media (max-width: 767px) {
        button {
          display: none;
        }
      }
    }

    @media (max-width: 767px) {
      flex-wrap: wrap;
      height: unset;
      gap: 20px;
    }
  }
`;

export default SelectSport;
